import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'packageStatusPipe'
})
export class PackageStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Active',
    1: 'Inactive',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }


}
